/* eslint-disable react/no-unescaped-entities,react/jsx-no-comment-textnodes */
import React from 'react';

import './AboutInfo.scss';

export const AboutInfo = () => {
  return (
    <div className="about__info">
      <h1>Imprint</h1>
      <h3>DECKMA HAMBURG GmbH</h3>
      Kieler Straße 316
      <br />
      22525 Hamburg Germany
      <br />
      <br />
      Tel.: +49(0)40 548876-0
      <br />
      Fax: +49(0)40 548876-10
      <br />
      E-Mail: post@deckma.com
      <br />
      Registered: Hamburg HRB 39129
      <br />
      <br />
      Managing Director: Anke Schulze
      <br />
      <br />
      VAT Registration No.: DE 118540659
      <br />
      <br />
      <br />
      <div>
        <h3>Data privacy statement</h3>
        <p>
          Data privacy statement for the website{' '}
          <a href="http://deckma.info">deckma.info</a> Responsible within the
          meaning of the Data privacy statment is:
        </p>
        <p>
          <strong>DECKMA HAMBURG GmbH</strong>
          <br /> Kieler Strasse 316
          <br /> 22525 Hamburg
          <br />
          GERMANY
        </p>
        <p>
          Tel: +49 (0) 405488760
          <br /> E-Mail: <a href="mailto:post@deckma.com">post@deckma.com</a>
        </p>
        <p>
          (hereinafter "we", "us") We appreciate your interest in our website.
          The protection of your privacy is very important to us. Below we
          inform you in detail about the collection of personal data when using
          our website. Personal data is all data that is personally available to
          you, eg. Name, address, e-mail addresses, user behavior. The legal
          foundations of data protection can be found in the Federal Data
          Protection Act (BDSG), the Telemedia Act (TMG) and the European
          General Data Protection Regulation (hereinafter also referred to as:
          "DSGVO"). We reserve the right to change this Privacy Policy from time
          to time to reflect legal and factual circumstances. Validity is always
          the explanation that is published when you visit our website. As a
          rule, you can call up all the websites of the Deckma Hamburg GmbH
          without giving any information about your person. If your name,
          address or other personal data is needed in individual cases, you will
          be informed in advance. We use your personal information to make the
          service and associated satisfaction of our customers as enjoyable as
          possible.
        </p>
        <p>
          1. Personal data Personal data are individual details about personal
          or factual circumstances of a specific or identifiable natural person.
          This includes information such as Your name, address and e-mail
          address. Information that is not directly related to your real
          identity - such as User-favorite websites in our website or the number
          of users of a page - are not personal data. If you decide to leave
          your personal data to Deckma Hamburg GmbH, so that Correspondence can
          be handled or an order can be executed, so this data is handled
          carefully according to the strict regulations of the General Data
          Protection Regulation (DGSVO).
        </p>
        <p>
          2. Collection of personal data when visiting our website We use
          hosting services to ensure the operation of the online offer. The
          hosting provider uses IT infrastructure services, computing capacity,
          storage space and database services, as well as security and technical
          maintenance services. In the case of merely informative use of our
          website, ie if you do not register or otherwise provide us with
          information, we only collect the personal data that your browser
          transmits to our server. This data is stored automatically for
          security purposes only. If you wish to view our website, we or our
          hosting provider collect the following data based on Art. 6 para. 1
          sentence 1 lit. f i. V. m. Art. 28 GDPR: IP address of the requesting
          computer,
        </p>
        <ul>
          <li>
            <p>
              date and time of request, Time zone difference to Greenwich Mean
              Time (GMT),
            </p>
          </li>
          <li>
            <p>content of the request (concrete page),</p>
          </li>
          <li>
            <p>Access Status / HTTP status code</p>
          </li>
          <li>
            <p>each transferred amount of data,</p>
          </li>
          <li>
            <p>Website that receives the request (referrer URL),</p>
          </li>
          <li>
            <p>used browsers,</p>
          </li>
          <li>
            <p>Operating system and its interface and</p>
          </li>
          <li>
            <p>
              Language and version of the browser software. The mentioned data
              are processed for the following purposes:
            </p>
          </li>
          <li>
            <p>ensuring a smooth connection of the website,</p>
          </li>
          <li>
            <p>ensuring comfortable use of our website,</p>
          </li>
          <li>
            <p>Evaluation of system security and stability as well</p>
          </li>
          <li>
            <p>for further administrative purposes.</p>
          </li>
        </ul>
        <p>
          Additional personal data will only be collected if you voluntarily
          provide this information, for example in the context of a request or a
          registration. The above-mentioned data is not usually assigned to
          certain people, and there is no merger of this data with other data
          sources. When contacting us (for example via contact form or e-mail),
          the details of the user are stored in order to process the request as
          well as in the event that follow-up questions arise. After complete
          rendering of the service and after expiry of the tax and commercial
          storage regulations, your personal data will be deleted completely,
          unless you have expressly consented to a further use of the data or
          this would otherwise be permitted or required by law.
        </p>
        <p>
          Your personal data will not be transmitted or disclosed to third
          parties, unless this is necessary for the purpose of using the
          functions of the website or for processing your requests or an order
          (for example, to commissioned technical service providers) or if you
          have expressly consented thereto.
        </p>
        <p>3. Cookies</p>
        <p>
          Like many other websites, we also use so-called "cookies". Cookies are
          small text files that are transferred to your hard disk by a website
          server. This automatically provides us with certain data such as IP
          address, browser used, operating system and your connection to the
          Internet.
        </p>
        <p>
          Cookies cannot be used to start programs or transfer viruses to a
          computer. We can use the information contained in cookies to make
          navigation easier for you and to enable our web pages to be displayed
          correctly.
        </p>
        <p>
          Under no circumstances will the data we collect be passed on to third
          parties or linked to personal data without your consent.
        </p>
        <p>
          Of course, you can always view our website without cookies. Internet
          browsers are regularly set to accept cookies. In general, you can
          deactivate the use of cookies at any time via the settings of your
          browser. Please use the help functions of your Internet browser to
          find out how to change these settings. Please note that individual
          functions of our website may not work if you have deactivated the use
          of cookies.
        </p>
        <p>
          4. Use of reCAPTCHA To protect entry forms on our site, we use the
          service "reCAPTCHA" from Google Inc., 1600 Amphitheater Parkway,
          Mountain View, CA 94043 USA. Through the use of this service, it can
          be distinguished whether the corresponding input is of human origin or
          abused by automated machine processing. To our knowledge the referrer
          URL, the IP address, the behavior of the website visitors, information
          about operating system, browser and duration, cookies, presentation
          instructions and scripts, the input behavior of the user as well as
          mouse movements in the area of the "reCAPTCHA" checkbox are
          transmitted to Google , Among other things, Google uses this
          information to digitize books and other printed matter, as well as to
          optimize services such as Google Street View and Google Maps (eg house
          number and street name recognition). The IP address submitted as part
          of "reCAPTCHA" will not be merged with any other data provided by
          Google unless you are logged in to your Google Account at the time you
          use the "reCAPTCHA" plug-in. If you want to prevent this transmission
          and storage of data about you and your behavior on our website by
          "Google", you must log out of "Google" before you visit our site or
          use the reCAPTCHA plug-in. The use of the service "reCAPTCHA" obtained
          information in accordance with the Google Terms of Use.{' '}
          <a href="http://www.google.com/intl/de/policies/privacy/">
            www.google.com/intl/de/policies/privacy/
          </a>
          .
        </p>
        <p>
          5. Technology - SSL encryption To ensure the security of data
          processing and to protect the transmission of confidential content,
          e.g. this page, contact requests, or orders you send us have SSL
          encryption (Secure Socket Layer Encryption). An encrypted connection
          can be recognized by the browser's address bar instead of an '' http:
          // '' 'https //' 'and the lock icon in your browser bar.
        </p>
        <p>
          Due to the SSL encryption, the data that you send to us can not be
          read by third parties.
        </p>
        <p>
          6. Safety We take all necessary technical and organizational security
          measures to protect your personal data from loss and misuse. This
          saves your data in a secure operating environment that is inaccessible
          to unauthorized persons. If you wish to contact us via e-mail, please
          bear in mind that the confidentiality of the information transmitted
          is never guaranteed 100% due to the nature of the Internet and that
          the content of e-mails can generally be viewed by unauthorized third
          parties.
        </p>
        <p>
          7. Your rights As the person concerned, you have the following rights
          with respect to the personal data concerning you:
        </p>
        <ul>
          <li>
            in accordance with Art. 15 DSGVO, to demand information about your
            personal data processed by us in the scope specified therein. In
            particular, you can provide information on the processing purposes,
            the category of personal data, the categories of recipients to whom
            your data has been disclosed, the planned retention period, the
            right to rectification, deletion, limitation of processing or
            opposition, the existence of a The right to complain, the source of
            their data, if not collected from us, and the existence of automated
            decision-making including profiling and, where appropriate,
            meaningful information about their details;
          </li>
          <li>
            in accordance with Art. 16 DSGVO, immediately demand the correction
            of incorrect or complete personal data stored with us;
          </li>
          <li>
            in accordance with Art. 17 DSGVO, to demand the deletion of your
            personal data stored by us, unless the processing for the exercise
            of the right to freedom of expression and information, for the
            fulfillment of a legal obligation, for reasons of public interest or
            for the assertion, exercise or defense of Legal claims is required;
          </li>
          <li>
            to demand the restriction of the processing of your personal data
            according to Art. 18 DSGVO, as far as the accuracy of the data is
            disputed by you, the processing is unlawful, but you reject its
            deletion and we no longer need the data, but you assert this,
            Exercise or defense of legal claims or you have objected to the
            processing in accordance with Art. 21 DSGVO;
          </li>
          <li>
            in accordance with Art. 20 DSGVO, to receive your personal data
            provided to us in a structured, standard and machine-readable format
            or to request transmission to another person responsible;
          </li>
          <li>
            according to Art. 7 para. 3 DSGVO, to revoke your once given consent
            to us at any time. As a result, we are not allowed to continue the
            data processing based on this consent for the future and
          </li>
          <li>
            to complain to a supervisory authority pursuant to Art. 77 DSGVO. As
            a rule, you can contact the supervisory authority of your usual
            place of residence or work or our company headquarters.
          </li>
        </ul>
        <p>
          If your personal data are based on legitimate interests in accordance
          with Art. 6 para. 1 sentence 1 lit. f DSGVO are processed, you have
          the right to file an objection against the processing of your personal
          data in accordance with Art. 21 DSGVO, provided that there are reasons
          for this arising from your particular situation or the objection is
          directed against direct mail. In the latter case, you have a general
          right of objection, which is implemented by us without specifying any
          particular situation. If you would like to exercise your right of
          revocation or objection, please send an e-mail to{' '}
          <a href="mailto:post@deckma.com"></a>
          <a href="mailto:post@deckma.com">post@deckma.com</a>
        </p>
        <p>
          8. Further legal information We do not permit third parties to use the
          contact data published in the imprint or similar information, such as
          postal addresses, telephone or fax numbers and e-mail addresses, for
          the purpose of sending information not expressly requested. Requests
          to enforce the rights set out in Section 6 and other requests for data
          protection are excluded and may be expressly requested.
        </p>
        <p>
          We reserve the right to take legal action against the senders of spam
          mails.
        </p>
        <p>
          9. Changes It is necessary to adapt the content of this Privacy
          Notice.-Therefore, we reserve the right to change it for the future.
          All changed versions of the privacy policy will also be published
          here. If you have any questions that this privacy policy does not
          answer to you or if you would like more in-depth information, please
          contact us at any time: DECKMA HAMBURG GmbH Kieler Strasse 316 22525
          Hamburg Tel: +49 (0) 405488760 e-mail:{' '}
          <a href="mailto:post@deckma.com">post@deckma.com</a>
        </p>
        <br />
        <br />
      </div>
    </div>
  );
};
